module.exports = __webpack_public_path__ + "static/NotoSans-Bold.subset-416a821471efda338e6d06a6c0a02c5f.otf";